import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sidebar } from '../../components/shared/Sidebar';
import { motion } from 'framer-motion';
import { CheckCircle, Download, Home } from 'lucide-react';
import { formatCurrency } from '../../utils/calculations';
import confetti from 'canvas-confetti';
export function PaymentSuccess() {
  const navigate = useNavigate();
  useEffect(() => {
    const duration = 3000;
    const end = Date.now() + duration;
    const frame = () => {
      confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: {
          x: 0
        },
        colors: ['#1D4ED8', '#10B981', '#F59E0B']
      });
      confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: {
          x: 1
        },
        colors: ['#1D4ED8', '#10B981', '#F59E0B']
      });
      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };
    frame();
  }, []);
  return <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors pb-16 lg:pb-0" data-id="element-4858">
      <Sidebar data-id="element-4859" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300 flex items-center justify-center p-4" data-id="element-4860">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="bg-white dark:bg-gray-800 rounded-3xl shadow-xl border border-gray-100 dark:border-gray-700 p-8 max-w-md w-full text-center relative overflow-hidden transition-colors" data-id="element-4861">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-green-400 to-blue-500" data-id="element-4862"></div>

          <div className="w-20 h-20 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce" data-id="element-4863">
            <CheckCircle className="h-10 w-10 text-green-600 dark:text-green-400" data-id="element-4864" />
          </div>

          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2" data-id="element-4865">
            Payment Successful!
          </h1>
          <p className="text-gray-500 dark:text-gray-400 mb-8" data-id="element-4866">
            Your rent payment has been processed securely.
          </p>

          <div className="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-6 mb-8 border border-gray-100 dark:border-gray-600 transition-colors" data-id="element-4867">
            <div className="flex justify-between mb-2" data-id="element-4868">
              <span className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-4869">
                Amount Paid
              </span>
              <span className="font-bold text-gray-900 dark:text-white" data-id="element-4870">
                {formatCurrency(150000)}
              </span>
            </div>
            <div className="flex justify-between mb-2" data-id="element-4871">
              <span className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-4872">
                Transaction ID
              </span>
              <span className="font-mono text-gray-900 dark:text-white text-sm" data-id="element-4873">
                TRX-89203942
              </span>
            </div>
            <div className="flex justify-between" data-id="element-4874">
              <span className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-4875">
                Date
              </span>
              <span className="font-medium text-gray-900 dark:text-white text-sm" data-id="element-4876">
                {new Date().toLocaleDateString()}
              </span>
            </div>
          </div>

          <div className="space-y-3" data-id="element-4877">
            <button className="w-full py-3 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-800 transition-colors flex items-center justify-center shadow-lg shadow-blue-200 dark:shadow-blue-900/30" data-id="element-4878">
              <Download className="h-5 w-5 mr-2 flex-shrink-0" data-id="element-4879" />
              Download Receipt
            </button>

            <button onClick={() => navigate('/tenant/dashboard')} className="w-full py-3 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-600 rounded-xl font-medium hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors flex items-center justify-center" data-id="element-4880">
              <Home className="h-5 w-5 mr-2 flex-shrink-0" data-id="element-4881" />
              Back to Dashboard
            </button>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700" data-id="element-4882">
            <p className="text-xs text-gray-400 dark:text-gray-500 break-words" data-id="element-4883">
              A confirmation email has been sent to your registered email
              address.
            </p>
          </div>
        </motion.div>
      </main>
    </div>;
}